import store from '@/store';
import { CustomTerms } from '@/types/CustomTerms';
import customTerms from '@/customterms.json';

export const customTerm = (rawString: string): string => {

  const userSettings = store.getters['theme/getCustomTermsSettings'];
  if (userSettings)
    (customTerms as CustomTerms).settings = {...(customTerms as CustomTerms).settings, ...userSettings};
  


  const replaceableTermsKey = getReplaceableTermsKey(rawString);

  const replaceableSentence = (customTerms as CustomTerms).terms[rawString];
  if (!replaceableSentence) {
    // We probably want to limit these to dev environment
    // eslint-disable-next-line no-console
    console.error(new Error(`CUSTOM TERM NOT FOUND ERROR! \nNo value found for: ${rawString} \n\nPOSSIBLE FIX: \nCheck your customTermsSettings.json, and make sure to only use custom terms defined in this file. \n`)); 

    return `Custom Term Not Found! => ${rawString}`;
  }
  const replacedFinalSentence = (customTerms as CustomTerms).terms[rawString][replaceableTermsKey];
  if (!replacedFinalSentence) {
    // eslint-disable-next-line no-console
    console.error(new Error(`CUSTOM TERM SETTINGS ERROR! \nNo value found for: ${replaceableTermsKey} \n\nPOSSIBLE FIX: \nCheck your customTermsSettings.json, and make sure to select a default option from the correct term list. \n`)); 
    return `Configuration Error Found! => ${rawString}`;
  }
  return replacedFinalSentence;
};

function getReplaceableTermsKey(rawString: string) :string{
  // match terms with the brackets [[]] and them remove brackets using replace
  const replaceableTerms = [...new Set(rawString.match(/\[\[.+?\]\]/g)?.map(item => item.replace(/(\[\[)|(\]\])/g, '').toLowerCase()))];
  return replaceableTerms.map(
    (term:string) => (customTerms as CustomTerms).settings[term.toLowerCase()]
  ).join('/');
    
}